// src/hooks/coinglass/useHolderRealizedPriceChart.ts

import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { holderRealizedPriceChartQueryOptions } from "@/services/queries/coinglass/coinglassQueries";
import type { HolderRealizedPriceQueryParams } from "@/types/indices";

/**
 * Custom hook for fetching Bitcoin Holder Realized Price chart data
 *
 * @param params - Optional query parameters (token_id, start_date, end_date, limit)
 * @returns Query result with chart data
 */
export function useHolderRealizedPriceChart(params?: HolderRealizedPriceQueryParams) {
  const query = useQuery(holderRealizedPriceChartQueryOptions(params));

  useEffect(() => {
    if (query.isLoading) console.log("[Hook] useHolderRealizedPriceChart loading...");
    if (query.isError) console.error("[Hook] useHolderRealizedPriceChart error:", query.error);
    if (query.data) console.log("[Hook] useHolderRealizedPriceChart data received");
  }, [query.isLoading, query.isError, query.data, query.error]);

  return {
    data: query.data?.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
